"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserAdInfoSchema = void 0;
exports.updateUserAdInfoSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'userName',
        'firstName',
        'lastName',
        'email',
        'objectID',
        'accountStatus',
        'preferredLanguage',
        'employeeID',
        'adUserType',
    ],
    properties: {
        userName: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        firstName: {
            type: 'string',
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string',
        },
        lastName: {
            type: 'string',
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string',
        },
        email: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        objectID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        accountStatus: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        phoneNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string between 0 and 100 characters or null',
        },
        fax: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string between 0 and 100 characters or null',
        },
        invitationStatus: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string or null',
        },
        preferredLanguage: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        employeeID: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        adUserType: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        title: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string or null',
        },
        inviteRedeemUrl: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string or null',
        },
    },
};
